import { Space, Typography, Radio } from "antd"
import { CheckCircleFilled } from "@ant-design/icons";

const { Title, Text } = Typography;

const Step3 = ({financingType, setFinancingType}) => {
    return (
        <div style={{ marginTop: 30 }}>
            <Space direction="vertical" size="small">
                <Title level={5} style={{ margin: 0 }}>
                    STEP 3 - Select Financing Type
                </Title>
                <Text style={{ color: "#40566D", fontSize: 14 }}>
                    Choose the type of invoice financing based on your transaction:
                </Text>
            </Space>

            <Radio.Group
                onChange={(e) => setFinancingType(e.target.value)}
                value={financingType}
                className="type-toggle"
            >
                <Radio value="LOB1000002">
                    {financingType === "LOB1000002" ? (
                        <CheckCircleFilled className="checked-icon" />
                    ) : (
                        <span className="unchecked-circle" />
                    )}
                    <span className="label">Receivable</span>
                </Radio>
                <Radio value="LOB1000001" disabled>
                    {financingType === "LOB1000001" ? (
                        <CheckCircleFilled className="checked-icon" />
                    ) : (
                        <span className="unchecked-circle" />
                    )}
                    <span className="label">Payable</span>
                </Radio>
            </Radio.Group>
        </div>
    )
}

export default Step3